import { render, staticRenderFns } from "./ProductBuy.vue?vue&type=template&id=3dae9524&scoped=true&"
import script from "./ProductBuy.vue?vue&type=script&lang=js&"
export * from "./ProductBuy.vue?vue&type=script&lang=js&"
import style0 from "./ProductBuy.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ProductBuy.vue?vue&type=style&index=1&id=3dae9524&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae9524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VImg,VListItem,VListItemTitle,VRow,VTextField})
